import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=2e4e54b0&scoped=true"
import script from "./CardContent.vue?vue&type=script&lang=js"
export * from "./CardContent.vue?vue&type=script&lang=js"
import style0 from "./CardContent.vue?vue&type=style&index=0&id=2e4e54b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e54b0",
  null
  
)

export default component.exports